<template>
  <div class="g-center top h-full">404</div>
</template>

<script>
export default {};
</script>

<style></style>
